import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  NavigationEnd,
  NavigationStart,
  Router,
  RouterLink,
} from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons';
import {
  faBars,
  faEnvelope,
  faSearch,
} from '@fortawesome/free-solid-svg-icons';
import { FcContactComponent } from '@shared/components/fc-contact/fc-contact.component';

@Component({
  selector: 'fc-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  imports: [
    CommonModule,
    FormsModule,
    RouterLink,
    FontAwesomeModule,
    FcContactComponent,
  ],
})
export class HeaderComponent {
  faFacebookF = faFacebookF;
  faEnvelope = faEnvelope;
  faBars = faBars;
  faSearch = faSearch;
  hideMobileNav: boolean = true;
  searchProduct: string = '';
  constructor(private router: Router) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.hideMobileNav = true;
      }
    });
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.searchProduct = '';
      }
    });
  }

  toggleMobileNav() {
    this.hideMobileNav = !this.hideMobileNav;
  }

  navigateToProductWithParams() {
    this.router.navigate(['/product'], {
      queryParams: { q: this.searchProduct },
    });
  }
}
